import { render, staticRenderFns } from "./RunningTotals.vue?vue&type=template&id=ec389d54&"
import script from "./RunningTotals.vue?vue&type=script&lang=js&"
export * from "./RunningTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports